BrowseNoDealsErrorPresenter = require '../presenters/no_deals_error'
BrowseNoDealsMessageTemplate = require '../../no_deals_message.html.mustache'

module.exports = BrowseNoDealsErrorView =
  template: BrowseNoDealsMessageTemplate

  render: (lastUpdatedRefinementId) ->
    return unless lastUpdatedRefinementId?.length
    noDealsHash = BrowseNoDealsErrorPresenter.toHash(lastUpdatedRefinementId)
    @template.render(noDealsHash) if noDealsHash
